export default {
      id: "user-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#user",
      toString: function () {
        return this.url;
      }
    }